import React, {useEffect, useState} from "react";
import "./style.scss";
import Overview from "../../components/Affiliate/Overview";
import AffilateCodes from "../../components/Affiliate/AffiliateCodes";
import Commission from "../../components/Affiliate/Commission";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Tabination from "../../reusableComponents/Tabination";
import GetALink from "../../components/Affiliate/GetALink/index";
import MainHeader from "../../layouts/pageLayout/MainHeader";
import PushLeads from "../../components/Affiliate/Overview/PushLeads";

function Affiliate() {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation(); // Get current route path

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);

    // Set the active tab based on the current path
    const path = location.pathname.split("/").pop();
    const activeTabIndex = items.findIndex((item) => item.path === path);
    setActiveTab(activeTabIndex === -1 ? 0 : activeTabIndex);
  }, [location]);

  const items = [
    {
      name: "Overview",
      path: "overview",
    },
    {
      name: "Get a Link",
      path: "get-a-link",
    },
  ];

  return (
    <>
      <div className="affContainer">
        <Tabination
          variant={7}
          tabItems={items}
          activeTab={activeTab}
          style={{ margin: "0 14px" }}
          className="tabination_all"
          cs={3}
        />
        <div className="affiliate">
          <Routes>
            <Route
              path="/"
              element={
                <Navigate
                  to="overview"
                  replace={true}
                />
              }
            />
            <Route
              path="overview"
              element={<Overview />}
            />
            <Route
              path="affiliate-codes"
              element={<AffilateCodes />}
            />
            <Route
              path="commission-payment"
              element={<Commission />}
            />
            <Route
              path="get-a-link"
              element={<GetALink />}
            />
            <Route
              path="*"
              element={
                <Navigate
                  to="/"
                  replace={true}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default Affiliate;
